import Button from "../baseComponents/Button/Button";
import {useDispatch} from "react-redux";
import {setShowBurgerMenu} from "../../actions/ui";
import {BURGER_MENU_LIST} from "./constants";
import useStyles from "./useStyles";
import TablerList from "../../icons/TablerList";

/* открывает бургер меню справочников */
export const DirectoryBurgerMenuShowButton = () => {

    const classes = useStyles();
    const dispatch = useDispatch()

    const showMobileMenu = () => {
        dispatch(
            setShowBurgerMenu({
                name: BURGER_MENU_LIST.DIRECTORY,
            })
        );
    };

    return (
        <Button
            className={classes.burgerMenuToggler}
            onClick={showMobileMenu}
            children={<TablerList />}/>
    )
}